module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1047-ed65e9867b01031afebb164ba1655e82.png";